module.exports = __webpack_public_path__ + "static/OpenSans-Italic-bf243bcbf81560535385c47725f57dfe.ttf";